// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { WhitePanelLayout } from '@dom/components';
import { Form } from '@sharingapples/form';
import queryString from 'query-string';
import differenceInDays from 'date-fns/difference_in_calendar_days';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';

import { useSelector } from '../../redux';
import { updateGuideSearchQuery } from '../../redux/actors';
import { getGuideSearchQuery,  } from '../../redux/selectors';

import {
  GuideSearchModify,
} from '../common';

const DATE_FORMAT = 'YYYY-MM-DD';

const INITIAL_VALUES = {
  pax: 1,
  guideQuery:'',
};

function SearchForm({ history, layout, title }) {

  const guideSearchQuery = useSelector(getGuideSearchQuery) || INITIAL_VALUES;

  const handleSubmit = (state) => {
    const query = { ...state };
    if (!query.guideQuery) query.guideQuery = 'Everest Base Camp';
    if(!query.startDate) {
      // IF START DATE IS EMPTY SET ITS VALUES TO A MONTH FROM NOW AND END DATE TO 14 DAYS AFTER START DATE 
      const aMonthFromNow = format(addDays(new Date(), 30), DATE_FORMAT);
      const fifteenDaysFromAMonth = format(addDays(aMonthFromNow, 14), DATE_FORMAT);

      query.startDate = aMonthFromNow;
      query.endDate = fifteenDaysFromAMonth;
    }
    const { guideQuery:trek , startDate, endDate, pax } = query;
    const  numberOfDays = differenceInDays(endDate, startDate) + 1;

    updateGuideSearchQuery({ ...query, numberOfDays });
    return history.push(`/list?${queryString.stringify({ trek, startDate, endDate, pax })}`);
  }
  
  return (
    <WhitePanelLayout className="sidebar-search">
      <Form defaultValue={guideSearchQuery} onSubmit={handleSubmit}>
        <GuideSearchModify />
      </Form>
    </WhitePanelLayout>
  );
};

export default withRouter(SearchForm);
